import React, {useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'

import {
  GetAllData,
  getBusinessName,
} from '../../../accounts/BusinessName/BusinessNameSlice/BusinessSlice'
import {
  GetAllData as GetCustomNumberList,
  getCustomNunberList,
} from '../../../accounts/CustomNumber/CustomNumberSlice/CustomNumberSlice'
import {
  getDedicatedNumber,
  getDedicatedNumberList,
} from '../../../accounts/DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'
import CreateCutomNumber from '../../../accounts/CustomNumber/Modal/CreateCutomNumber'
import CreateBusinessNamePopup from '../../../accounts/BusinessName/Modal/CreateBusinessNamePopup'
import {Elements} from '@stripe/react-stripe-js'
import VirtualNumbersModal from '../../../accounts/DedicatedNumber/VirtualNumbersModal'
import {AuthenticateUser} from '../../../../../Utils/_helpers/RoleAndPermission'
import Select from 'react-select'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
import {BulkMsgDraftData} from '../../BulkMessageSlice/BulkMessageSlice'
import StripeJSProvider from '../../../../../Utils/StripeJSProvider'
import {GLOBAL_SETTINGS_TYPE, REGION} from '../../../../../Utils/Constant/ConstantForWebsite'
import {getAllUserDetails} from '../../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useNewMessage} from '../../useNewMessage'
import {toUpper} from 'lodash'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import ModalDetailCustomBusiness from '../../../sender-id/modal/ModalDetailCustomBusiness'
import ModalDetailCustomNumber from '../../../sender-id/modal/ModalDetailCustomNumber'
import ModalDetailDedicatedNumber from '../../../sender-id/modal/ModalDetailDedicatedNumber'

const Bulk_Message_Send_From_V2 = ({
  setBulkMessageData,
  bulkMessageData,
  checkStep,
  error,
  setMMSError,
  setError,
  setCheckStep,
}: any) => {
  const [name, setName] = useState(false)
  const [businessName, setBusinessName] = useState(false)
  const [visible, setVisible] = useState<any>(false)
  const dispatch = useDispatch()
  const virtualNumber = useSelector(getDedicatedNumber)
  const CustomNumberList = useSelector(getCustomNunberList)
  const bussinessName = useSelector(getBusinessName)
  const OptOutDefault = useSelector((state: any) => state?.userDetails?.userDetails?.data?.user)
  const {isDefaultRegion, currentRegion} = useNewMessage()
  const [showModalDetailLearMore, setShowModalDetailLearMore] = useState(false)

  const [defaultSelectFrom, setDefaultSelectFrom] = useState('shared')

  const DedicatedNumber: any = useSelector(getDedicatedNumber)
  const optoutList = useSelector((state: any) => {
    const userGlobalSettings = state?.userDetails?.userDetails?.data?.user?.globalSetting
    let list = state?.optoutList?.optoutList?.data?.items || []

    if (bulkMessageData?.camp_type === 'sms') {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        GLOBAL_SETTINGS_TYPE.BULK_SMS_REPLY_STOP_OUTPUT
      )
      list = isDisableReplyByGlobalOption ? list : []
    }

    if (bulkMessageData?.camp_type === 'mms') {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        GLOBAL_SETTINGS_TYPE.BULK_MMS_REPLY_STOP_OUTPUT
      )
      list = isDisableReplyByGlobalOption ? list : []
    }

    return list
  })

  useEffect(() => {
    if (Array.isArray(DedicatedNumber)) {
      const dnDefault = DedicatedNumber?.find((key: any) => {
        if (bulkMessageData?.camp_type?.toUpperCase() === 'MMS') {
          return key?.type === 'MMS' && key?.isDefault === true && key?.status === 'active'
        }
        return key?.isDefault === true && key?.status === 'active'
      })

      if (dnDefault) {
        setBulkMessageData({
          ...bulkMessageData,
          sender: {
            value: dnDefault.audNumber,
            label: `${dnDefault.audNumber}`,
            disabled: false,
          },
          senderType: 'dedicatedNumber',
        })
        dispatch(
          BulkMsgDraftData({
            ...bulkMessageData,
            sender: {
              value: dnDefault.audNumber,
              label: `${dnDefault.audNumber}`,
              disabled: false,
            },
            senderType: 'dedicatedNumber',
          })
        )
      }
    }
  }, [DedicatedNumber])

  useEffect(() => {
    dispatch(GetAllData())
    dispatch(GetCustomNumberList())
    dispatch(getDedicatedNumberList())
  }, [])

  const userDetail: any = useSelector(getAllUserDetails)
  const [isShowCredit, setIsShowCredit] = useState(true)
  useEffect(() => {
    if (userDetail && userDetail.subClientAccountId && userDetail.subClientAccountId !== '') {
      if (userDetail._id !== userDetail.ownerId) {
        setIsShowCredit(false)
      }
    }
  }, [userDetail])

  const Customnumber = useMemo(
    () => <CreateCutomNumber show={name} handleClose={() => setName(false)} />,
    [name]
  )

  const BusinessName = useMemo(
    () => (
      <CreateBusinessNamePopup show={businessName} handleClose={() => setBusinessName(false)} />
    ),
    [businessName]
  )

  const DetailCustomBusiness = useMemo(
    () => (
      <ModalDetailCustomBusiness
        showActionButton={false}
        show={bulkMessageData?.senderType === 'businessName' && showModalDetailLearMore}
        handleClose={() => setShowModalDetailLearMore(false)}
        onClickActionButton={() => {
          setShowModalDetailLearMore(false)
        }}
      />
    ),
    [bulkMessageData?.senderType, showModalDetailLearMore]
  )

  const DetailDedicatedNumber = useMemo(
    () => (
      <ModalDetailDedicatedNumber
        showActionButton={false}
        show={bulkMessageData?.senderType === 'dedicatedNumber' && showModalDetailLearMore}
        handleClose={() => setShowModalDetailLearMore(false)}
        onClickActionButton={() => {
          setShowModalDetailLearMore(false)
        }}
      />
    ),
    [bulkMessageData?.senderType, showModalDetailLearMore]
  )

  const DetailCustomNumber = useMemo(
    () => (
      <ModalDetailCustomNumber
        showActionButton={false}
        show={bulkMessageData?.senderType === 'customNumber' && showModalDetailLearMore}
        handleClose={() => setShowModalDetailLearMore(false)}
        onClickActionButton={() => {
          setShowModalDetailLearMore(false)
        }}
      />
    ),
    [bulkMessageData?.senderType, showModalDetailLearMore]
  )

  const getSubtitle = (): string => {
    if (bulkMessageData?.senderType !== '' && bulkMessageData?.sender !== '') {
      let subtitle

      switch (bulkMessageData?.senderType) {
        case '#SharedNum#':
          subtitle = 'Shared Number'
          break
        case 'businessName':
          subtitle = 'Business Name'
          break
        case 'dedicatedNumber':
          subtitle = 'Dedicated Number'
          break
        case 'customNumber':
          subtitle = 'Your Own Number'
          break
        default:
          subtitle = 'Select how your message will be sent.'
      }

      return subtitle
    } else {
      return 'Select how your message will be sent.'
    }
  }

  return (
    <>
      {BusinessName}
      {Customnumber}
      {DetailCustomBusiness}
      {DetailCustomNumber}
      {DetailDedicatedNumber}

      {AuthenticateUser('purchase-dedicated-number') && (
        <StripeJSProvider>
          {({stripe}: any) =>
            stripe ? (
              <Elements stripe={stripe}>
                <VirtualNumbersModal show={visible} handleClose={() => setVisible(false)} />
              </Elements>
            ) : null
          }
        </StripeJSProvider>
      )}
      <h2
        className={`accordion-header ${
          bulkMessageData.sender !== '' && bulkMessageData?.senderType !== '' && 'successData'
        }`}
        id='headingThree'
      >
        <button
          className='collapsed accordion-button'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseThree'
          aria-expanded='false'
          aria-controls='collapseThree'
          style={{paddingBottom: 2}}
          onClick={() => {
            setCheckStep({
              gettingStarted: false,
              to: false,
              from: !checkStep?.from,
              message: false,
              when: false,
            })
          }}
        >
          <div className='d-flex flex-column align-items-start gap-1'>
            <span className={checkStep?.from ? 'text-primary' : ''}>From</span>
            <span className='accordion-subtitle fs-6 fw-normal lh-base'>{getSubtitle()} </span>
          </div>
        </button>

        <div className='bulk-message-collapse'>
          <div
            className='accordion-title-detail small'
            style={{
              color: `${
                bulkMessageData?.senderType !== '' && bulkMessageData?.sender !== ''
                  ? '#1A1C37'
                  : ''
              }`,
            }}
          >
            Sender ID{' '}
            {!!bulkMessageData.sender?.value &&
              ': ' +
                (bulkMessageData.sender?.value === '#SharedNum#'
                  ? 'Shared Number'
                  : bulkMessageData.sender?.value)}
          </div>
          {/* <button
            type='button'
            className='btn-toggle-bulk'
            data-bs-toggle='collapse'
            data-bs-target='#collapseThree'
            aria-expanded='false'
            aria-controls='collapseThree'
          >
            Click
          </button> */}
        </div>
      </h2>

      {!(bulkMessageData?.senderType !== '' && bulkMessageData?.sender !== '') && (
        <div
          className='fs-6 fw-normal lh-base'
          style={{padding: '0px 32px 16px 54px', color: '#7F7878'}}
        >
          Best practice{' '}
          <a
            href='#'
            onClick={(e) => {
              e.preventDefault() // optional, to prevent the page from jumping to top
              setShowModalDetailLearMore(true)
            }}
          >
            learn more
          </a>
        </div>
      )}
      <div
        id='collapseThree'
        className={`accordion-collapse collapse ${checkStep.from && 'show'}`}
        aria-labelledby='headingThree'
        data-bs-parent='#accordionExample'
      >
        <div className='accordion-body'>
          <ul className='nav nav-tabs' id='myTab' role='tablist'>
            <OverlayTrigger
              placement='top'
              overlay={
                <Tooltip id='button-tooltip'>
                  Standard shared number is a set of local numbers that can be used to send by all
                  cellcast users.
                </Tooltip>
              }
            >
              <li className='nav-item mb-3 me-3' role='presentation'>
                <button
                  className={clsx(
                    'nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-3',
                    {active: bulkMessageData.senderType === '#SharedNum#'},
                    {'d-none': [REGION.UK].includes(currentRegion)}
                  )}
                  id='Shared-number-tab'
                  data-bs-toggle='tab'
                  data-bs-target='#Shared-number'
                  type='button'
                  role='tab'
                  aria-controls='Shared number'
                  aria-selected='true'
                  onClick={() => {
                    let replyStopToOptOut = !!bulkMessageData?.optoutId
                      ? bulkMessageData?.replyStopToOptOut
                      : true

                    if (!optoutList?.length) {
                      replyStopToOptOut = false
                    }

                    let errorData = {...error}
                    delete errorData.sender
                    setError(errorData)
                    setBulkMessageData({
                      ...bulkMessageData,
                      sender: {value: '#SharedNum#', label: '#SharedNum#'},
                      senderType: '#SharedNum#',
                      replyStopToOptOut: replyStopToOptOut,
                    })
                    dispatch(
                      BulkMsgDraftData({
                        ...bulkMessageData,
                        scheduledAt: '',
                        sender: {value: '#SharedNum#', label: '#SharedNum#'},
                        senderType: '#SharedNum#',
                        replyStopToOptOut: replyStopToOptOut,
                      })
                    )
                    setMMSError(false)
                  }}
                >
                  Shared number
                </button>
              </li>
            </OverlayTrigger>

            <OverlayTrigger
              placement='top'
              overlay={
                <Tooltip id='button-tooltip'>
                  Add branding to your messages by sending with a custom name. Available only for
                  SMS, at a cost of 1.3 credits per sms. one-way sms only.
                </Tooltip>
              }
            >
              <li className='nav-item mb-3 me-3' role='presentation'>
                <button
                  className={clsx(
                    {'d-none': !isDefaultRegion && ![REGION.UK].includes(currentRegion)},
                    'nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-3',
                    {
                      active:
                        bulkMessageData.senderType === 'businessName' &&
                        bulkMessageData.sender !== '',
                    }
                  )}
                  id='Business-name-tab'
                  data-bs-toggle='tab'
                  data-bs-target='#Business-name'
                  type='button'
                  role='tab'
                  aria-controls='Business-name'
                  aria-selected='false'
                  onClick={() => {
                    const DefaultOptout = optoutList?.find(
                      (key: any) => key?._id == OptOutDefault?.defaultOptoutId
                    )
                    let tempOptout: any = {optout: false, optoutId: ''}
                    if (DefaultOptout?.title) {
                      tempOptout = {
                        ...tempOptout,
                        optout: true,
                        optoutId: DefaultOptout?._id,
                        optoutLabel: DefaultOptout?.title,
                      }
                    } else {
                      if (optoutList?.length > 0) {
                        tempOptout = {
                          ...tempOptout,
                          optout: true,
                          optoutId: optoutList?.[0]?._id,
                          optoutLabel: optoutList?.[0]?.title,
                        }
                      }
                    }

                    const findDefaultSenderId = bussinessName?.find((it: any) => it?.isDefault)

                    const defaultSenderId = findDefaultSenderId
                      ? {
                          value: findDefaultSenderId?.businessname,
                          label: findDefaultSenderId?.businessname,
                        }
                      : ''

                    setBulkMessageData({
                      ...bulkMessageData,
                      scheduledAt: '',
                      sender: defaultSenderId,
                      senderType: 'businessName',
                      replyStopToOptOut: false,
                      ...tempOptout,
                    })
                    dispatch(
                      BulkMsgDraftData({
                        ...bulkMessageData,
                        scheduledAt: '',
                        sender: defaultSenderId,
                        senderType: 'businessName',
                        replyStopToOptOut: false,
                        ...tempOptout,
                      })
                    )
                    setMMSError(false)
                  }}
                >
                  Business name
                </button>
              </li>
            </OverlayTrigger>

            <OverlayTrigger
              placement='top'
              overlay={
                <Tooltip id='button-tooltip'>
                  A Dedicated Number, unique to your business, ensures the highest sender reputation
                  and avoids spam filters, guaranteeing your messages are delivered without
                  blockage.
                </Tooltip>
              }
            >
              <li className='nav-item mb-3 me-3' role='presentation'>
                <button
                  className={clsx(
                    {'d-none': [REGION.UK].includes(currentRegion)},
                    'nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-3',
                    {
                      active:
                        bulkMessageData.senderType === 'dedicatedNumber' &&
                        bulkMessageData.sender !== '',
                    }
                  )}
                  id='Dedicated-number-tab'
                  data-bs-toggle='tab'
                  data-bs-target='#Dedicated-number'
                  type='button'
                  role='tab'
                  aria-controls='Dedicated-number'
                  aria-selected='false'
                  onClick={() => {
                    let dedicatedNumber = virtualNumber
                      ? virtualNumber
                      : [{value: '', label: 'Select'}]

                    const DefaultSetValue = [...dedicatedNumber]?.find((key: any) => key?.isDefault)

                    const DefaultNumber = DefaultSetValue
                      ? {value: DefaultSetValue?.audNumber, label: DefaultSetValue?.audNumber}
                      : ''

                    let replyStopToOptOut = !!bulkMessageData?.optoutId
                      ? bulkMessageData?.replyStopToOptOut
                      : true

                    if (!optoutList?.length) {
                      replyStopToOptOut = false
                    }

                    setBulkMessageData({
                      ...bulkMessageData,
                      sender: DefaultNumber,
                      senderType: 'dedicatedNumber',
                      replyStopToOptOut: replyStopToOptOut,
                    })
                    dispatch(
                      BulkMsgDraftData({
                        ...bulkMessageData,
                        scheduledAt: '',
                        sender: DefaultNumber,
                        senderType: 'dedicatedNumber',
                        replyStopToOptOut: replyStopToOptOut,
                      })
                    )
                    setMMSError(false)
                  }}
                >
                  Dedicated number
                </button>
              </li>
            </OverlayTrigger>

            <OverlayTrigger
              placement='top'
              overlay={
                <Tooltip id='button-tooltip'>
                  Send sms from a custom number, making it appear as the sender. Replies & calls go
                  directly to this number without showing in our system. Sending cost: 1.3 credits.
                </Tooltip>
              }
            >
              <li className='nav-item mb-3' role='presentation'>
                <button
                  className={clsx(
                    {'d-none': !isDefaultRegion},
                    'nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-3',
                    {
                      active:
                        bulkMessageData.senderType === 'customNumber' &&
                        bulkMessageData.sender !== '',
                    }
                  )}
                  id='Custom-number-tab'
                  data-bs-toggle='tab'
                  data-bs-target='#Custom-number'
                  type='button'
                  role='tab'
                  aria-controls='Custom-number'
                  aria-selected='false'
                  onClick={() => {
                    let dedicatedNumber = CustomNumberList
                      ? CustomNumberList
                      : [{value: '', label: 'Select'}]
                    const DefaultSetValue = [...dedicatedNumber]?.find((key: any) => key?.isDefault)
                    const DefaultNumber = DefaultSetValue
                      ? {value: DefaultSetValue?.number, label: DefaultSetValue?.number}
                      : ''

                    const DefaultOptout = optoutList?.find(
                      (key: any) => key?._id == OptOutDefault?.defaultOptoutId
                    )
                    let tempOptout: any = {optout: false, optoutId: ''}
                    if (DefaultOptout?.title) {
                      tempOptout = {
                        ...tempOptout,
                        optout: true,
                        optoutId: DefaultOptout?._id,
                        optoutLabel: DefaultOptout?.title,
                      }
                    } else {
                      if (optoutList?.length > 0) {
                        tempOptout = {
                          ...tempOptout,
                          optout: true,
                          optoutId: optoutList?.[0]?._id,
                          optoutLabel: optoutList?.[0]?.title,
                        }
                      }
                    }
                    setBulkMessageData({
                      ...bulkMessageData,
                      sender: DefaultNumber,
                      senderType: 'customNumber',
                      replyStopToOptOut: false,
                      ...tempOptout,
                    })

                    dispatch(
                      BulkMsgDraftData({
                        ...bulkMessageData,
                        scheduledAt: '',
                        sender: DefaultNumber,
                        senderType: 'customNumber',
                        replyStopToOptOut: false,
                        ...tempOptout,
                      })
                    )
                    setMMSError(false)
                  }}
                >
                  Your own number
                </button>
              </li>
            </OverlayTrigger>
          </ul>

          <div className='tab-content' id='myTabContent'>
            <div
              className={`tab-pane fade ${
                bulkMessageData.senderType === '#SharedNum#' && 'active show'
              }`}
              id='Shared-number'
              role='tabpanel'
              aria-labelledby='Shared-number-tab'
            ></div>

            <div
              className={`tab-pane fade ${
                bulkMessageData.senderType === 'businessName' && 'active show'
              }`}
              id='Business-name'
              role='tabpanel'
              aria-labelledby='Business-name-tab'
            >
              <label className='mb-2'>Sender ID</label>
              <div className='d-flex flex-column flex-sm-row align-items-center'>
                <Select
                  placeholder={'Select Business name'}
                  value={bulkMessageData?.sender}
                  name='selector'
                  data-testid='ddBusinessName'
                  className='form-select bg-light-primary border-0 mw-xl-75 py-4'
                  options={bussinessName
                    ?.filter((key: any) => key?.status == 'ACTIVE')
                    ?.map((key: any) => ({
                      value: key?.businessname,
                      label: key?.businessname,
                    }))}
                  onChange={(e: any) => {
                    let errorData = {...error}
                    delete errorData.sender
                    setError(errorData)
                    setBulkMessageData({
                      ...bulkMessageData,
                      sender: e,
                      senderType: 'businessName',
                    })

                    dispatch(
                      BulkMsgDraftData({
                        ...bulkMessageData,
                        scheduledAt: '',
                        sender: e,
                        senderType: 'businessName',
                      })
                    )
                  }}
                />

                {AuthenticateUser('create-new-business-name') && (
                  <button
                    onClick={() => setBusinessName(true)}
                    className='btn btn-primary m-2 p-4 text-nowrap ms-4 msg-primary-btn px-7'
                    data-testid='btnAddNewBusinessName'
                  >
                    New Business name
                  </button>
                )}
              </div>
            </div>

            <div
              className={`tab-pane fade ${
                bulkMessageData.senderType === 'dedicatedNumber' && 'active show'
              }`}
              id='Dedicated-number'
              role='tabpanel'
              aria-labelledby='Dedicated-number-tab'
            >
              <label className='mb-2' data-testid='labelSenderId'>
                Sender ID
              </label>
              <div className='d-flex flex-column flex-sm-row align-items-center'>
                <Select
                  placeholder={'Select Dedicated number'}
                  value={bulkMessageData?.sender}
                  name='selector'
                  data-testid='ddDedicatedNumber'
                  className='form-select bg-light-primary border-0 mw-xl-75 py-4'
                  options={[
                    {
                      label: 'MMS',
                      options: DedicatedNumber?.filter(
                        (key: any) => toUpper(key?.type) == 'MMS'
                      )?.map((key: any) => {
                        return {
                          value: key.audNumber,
                          label: `${key.audNumber}`,
                          disabled: key?.status === 'inactive',
                        }
                      }),
                    },
                    {
                      label: 'SMS',
                      options: DedicatedNumber?.filter(
                        (key: any) => toUpper(key?.type) === 'SMS' || toUpper(key?.type) === 'VOICE'
                      )?.map((key: any) => {
                        return {
                          value: key.audNumber,
                          label: `${key.audNumber}`,
                          disabled: key?.status === 'inactive',
                        }
                      }),
                    },
                  ]}
                  onChange={(e: any) => {
                    let typeData = DedicatedNumber?.find(
                      (key: any) => key.audNumber === e.value
                    )?.type

                    let errorData = {...error}
                    delete errorData.sender

                    const payload: any = {
                      ...bulkMessageData,
                      sender: e,
                      senderType: 'dedicatedNumber',
                    }

                    // Only clear media/message when switching from MMS to SMS type
                    if (
                      typeData?.toLowerCase() === 'sms' &&
                      bulkMessageData?.camp_type?.toLowerCase() === 'mms'
                    ) {
                      payload.media = ''
                      payload.gif = ''
                      payload.message = ''
                    }

                    if (
                      typeData?.toLowerCase() === 'sms'
                    ) {
                      payload.camp_type = typeData?.toLowerCase()
                    }

                    setError(errorData)
                    setBulkMessageData(payload)

                    const draftPayload = {
                      ...payload,
                      scheduledAt: '',
                    }
                    dispatch(BulkMsgDraftData(draftPayload))
                  }}
                  isOptionDisabled={(option: any, value: any) =>
                    option?.disabled ? option?.disabled : false
                  }
                />

                {AuthenticateUser('purchase-dedicated-number') && isShowCredit && (
                  <button
                    onClick={() => setVisible(true)}
                    className='btn btn-primary m-2 p-4 text-nowrap msg-primary-btn'
                    data-testid='btnAddDedicatedNumber'
                  >
                    New Dedicated number
                  </button>
                )}
              </div>
            </div>

            <div
              className={`tab-pane fade ${
                bulkMessageData.senderType === 'customNumber' && 'active show'
              }`}
              id='Custom-number'
              role='tabpanel'
              aria-labelledby='Custom-number-tab'
            >
              <label className='mb-2' data-testid='labelSenderID'>
                Sender ID
              </label>
              <div className='d-flex flex-column flex-sm-row align-items-center'>
                <Select
                  placeholder={'Select your own number'}
                  value={bulkMessageData?.sender}
                  name='selector'
                  data-testid='ddYourOwnNumber'
                  className='form-select bg-light-primary border-0 mw-xl-75 py-4'
                  options={CustomNumberList?.map((key: any) => ({
                    value: key?.number,
                    label: key?.number,
                  }))}
                  onChange={(e: any) => {
                    let errorData = {...error}
                    delete errorData.sender
                    setError(errorData)
                    setBulkMessageData({
                      ...bulkMessageData,
                      sender: e,
                      senderType: 'customNumber',
                    })

                    dispatch(
                      BulkMsgDraftData({
                        ...bulkMessageData,
                        scheduledAt: '',
                        sender: e,
                        senderType: 'customNumber',
                      })
                    )
                  }}
                />

                {AuthenticateUser('create-custom-number') && (
                  <button
                    onClick={() => setName(true)}
                    className='btn btn-primary m-2 p-4 text-nowrap ms-4 msg-primary-btn px-7'
                    data-testid='btnAddCustomNumber'
                  >
                    + Custom number
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Bulk_Message_Send_From_V2
